import { Reveal, Marquee } from "@/lib/motion";
import { PageHero, SectionHeading, GoldLink, Overline } from "@/components/ui-kit";
import { useSeo } from "@/lib/useSeo";

const VALUES = [
  ["Honest", "Transparent BOQ and pricing on every project."],
  ["Boutique", "A limited number of homes at a time, by design."],
  ["Crafted", "Premium materials and meticulous detailing."],
  ["Client-first", "One dedicated Relationship Manager, always."],
];
const STATS = [["120+", "Homes Delivered"], ["10yr", "Warranty Support"], ["4.9", "Average Rating"], ["100%", "Turnkey Projects"]];

export default function About() {
  useSeo({ title: "About", description: "Sutra Interio is Kolkata's boutique luxury interior design and turnkey execution studio." });
  return (
    <div data-testid="about-page">
      <PageHero overline="Our Story" title="A boutique studio for" italic="considered living."
        sub="Sutra Interio was founded on a simple belief — that luxury is not loudness, but honesty, craft and calm. We design and execute a limited number of homes each year, so every space receives genuine attention."
        image="https://images.pexels.com/photos/35361419/pexels-photo-35361419.jpeg?auto=compress&cs=tinysrgb&w=1400" />

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 py-20 md:py-28 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-6">
          <SectionHeading overline="Philosophy" title="We design the way" italic="you actually live." />
        </div>
        <div className="lg:col-span-6">
          <Reveal>
            <p className="text-lg text-ink/75 leading-relaxed">
              From our studio in Kolkata, we bring together architecture, interiors and turnkey execution under one roof. Every project begins with listening — to your rituals, your taste and your budget — and ends with a home that feels effortless.
            </p>
            <p className="mt-5 text-ink/70 leading-relaxed">
              Technology keeps it transparent: a live client portal, digital approvals and daily site updates mean you are never left wondering. Craftsmanship keeps it timeless.
            </p>
            <div className="mt-8"><GoldLink to="/services" testid="about-services-link">Explore Services</GoldLink></div>
          </Reveal>
        </div>
      </section>

      <div className="bg-cream border-y border-gold/20 py-6">
        <Marquee text="Elegant · Honest · Transparent · Crafted · Calm" className="font-display italic text-3xl md:text-5xl text-ink/25" />
      </div>

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 py-20 md:py-28">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {VALUES.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.08}>
              <Overline>{String(i + 1).padStart(2, "0")}</Overline>
              <h3 className="font-display text-3xl mt-3">{t}</h3>
              <p className="text-ink/65 text-lg mt-2 leading-relaxed">{d}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-olive text-beige py-20 md:py-28 grain relative">
        <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-2 lg:grid-cols-4 gap-10 text-center">
          {STATS.map(([n, l], i) => (
            <Reveal key={l} delay={i * 0.08}>
              <p className="font-display text-6xl md:text-7xl text-gold">{n}</p>
              <p className="overline !text-ivory/60 mt-3">{l}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
